import { render, staticRenderFns } from "./sidebarfilterscontent.vue?vue&type=template&id=550ea417&scoped=true"
import script from "./sidebarfilterscontent.vue?vue&type=script&lang=js"
export * from "./sidebarfilterscontent.vue?vue&type=script&lang=js"
import style0 from "./sidebarfilterscontent.vue?vue&type=style&index=0&id=550ea417&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550ea417",
  null
  
)

export default component.exports